import type { Product, ProductMediaType } from '../types';

const bookTokens = new Set(['book', 'books', 'written', 'physical', 'digital', 'ebook', 'e-book', 'text']);
const audioTokens = new Set(['audio', 'audiobook', 'audio-book', 'podcast', 'voice']);
const animationTokens = new Set(['animation', 'animated', 'cartoon', 'video']);

const normalizeToken = (value: string): string =>
  value.trim().toLowerCase().replace(/[_\s]+/g, '-');

export const normalizeProductMediaType = (value: unknown): ProductMediaType | undefined => {
  if (typeof value !== 'string' || !value.trim()) {
    return undefined;
  }

  const normalized = normalizeToken(value);

  if (bookTokens.has(normalized)) {
    return 'book';
  }

  if (audioTokens.has(normalized)) {
    return 'audio';
  }

  if (animationTokens.has(normalized)) {
    return 'animation';
  }

  return undefined;
};

export const getProductMediaType = (product: Product): ProductMediaType =>
  normalizeProductMediaType(product.mediaType) ?? 'book';

export const filterProductsByMediaType = (products: Product[], mediaType: ProductMediaType): Product[] =>
  products.filter((product) => getProductMediaType(product) === mediaType);
